import { BAD_REQUEST, CONFLICT, MOVED_PERMANENTLY } from 'http-status-codes';
import { get } from 'lodash';
import {
	UPDATE_ADD_PAYEE_FORM,
	SUBMIT_ADD_PAYEE_FAILURE,
	RESET_ADD_PAYEE_FORM,
	RESET_ADD_PAYEE_FORM_ERRORS,
	SET_ADD_PAYEE_FORM,
	INIT_ADD_PAYEE_FORM,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE,
	SET_GENERIC_ERROR,
} from './actions';
import { SUBMIT_DELETE_PAYEE_SUCCESS } from '../../../managePayee/states/action';

export const initialState = {
	addPayee: {
		linkAccount: '',
		name: '',
		sortCode: '',
		accountNumber: '',
		reference: '',
		singleUse: false,
		displayName: '',
		showError: false,
		errorCode: '',
		chapsPaymentsEnable: false,
		chapsReference: '',
		payeeAddressLine1: '',
		payeeAddressLine2: '',
		payeeCity: '',
		payeePostalCode: '',
		payeeCountry: 'GB',
	},
	addInternationalPayee: {
		linkAccount: '',
		internationalPayeeName: '',
		singleUse: false,
		displayName: '',
		showError: false,
		errorCode: '',
		payeeAddressLine1: '',
		payeeAddressLine2: '',
		payeeCity: '',
		payeePostalCode: '',
		payeeCountry: '',
		payeeAccountType: 'iban',
		iban: '',
		internationalAccountNumber: undefined,
		paymentReason: '',
		bickOrSwift: undefined,
		clearingCode: undefined,
		noBicOrSwift: false,
		bankAddressLine1: undefined,
		bankAddressLine2: undefined,
		bankCity: undefined,
		bankPostalCode: undefined,
		bankCountry: undefined,
		bankName: undefined,
	},
};
const addPayeeForm = (state = {}, action) => {
	switch (action.type) {
		case INIT_ADD_PAYEE_FORM:
			return { ...initialState[action.id], ...action.initialValues };
		case UPDATE_ADD_PAYEE_FORM:
			return { ...state, ...action.value };
		case RESET_ADD_PAYEE_FORM:
			return { ...initialState[action.id] };
		case SUBMIT_DELETE_PAYEE_SUCCESS: {
			return { ...state, isPayeeDeleted: true };
		}
		case SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE:
		case SUBMIT_ADD_PAYEE_FAILURE: {
			const {
				payload: { status, response = {} },
			} = action;
			const { coded_exceptions = [] } = response;
			if (status === CONFLICT) {
				return { ...state, showError: true, errorCode: status };
			}
			if (
				status === BAD_REQUEST &&
				(Number(get(coded_exceptions, '[0].error_code', '') || 0) === MOVED_PERMANENTLY ||
					get(coded_exceptions, '[0].error_code', '') === '23')
			) {
				return { ...state, showError: true, errorCode: coded_exceptions[0].error_code };
			}
			return { ...state, hasError: true };
		}
		case RESET_ADD_PAYEE_FORM_ERRORS:
			return { ...state, showError: false, errorCode: '' };
		case SET_GENERIC_ERROR:
			return { ...state, showError: true, errorCode: action.errorCode };

		case SET_ADD_PAYEE_FORM:
			return { ...state, ...action.payeeDetails };
		default:
			return state;
	}
};
export default addPayeeForm;
